import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReply = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.78 12.38l-4-5a1 1 0 00-1.56 1.24l2.7 3.38H8a1 1 0 01-1-1V6a1 1 0 10-2 0v5a3 3 0 003 3h8.92l-2.7 3.38A1 1 0 0015 19a1 1 0 00.78-.38l4-5a1 1 0 000-1.24z",
			fillRule: "nonzero"
		})
	})
});
export { SvgReply as ReactComponent };
